import * as base from "./base";
import * as derived from "./derived";

/**
 * Selection selectors namespace
 *
 * Usage:
 * - selection.allUids(state) - Get all selected object UIDs
 * - selection.hasSelection(state) - Check if anything is selected
 * - selection.elementUids(state) - Get selected element UIDs (memoized)
 * - selection.elements(state) - Get selected elements (memoized)
 * - selection.netUids(state) - Get selected net UIDs (memoized)
 */
export const selection = {
    ...base,
    ...derived,
} as const;

export type SelectionSelectors = typeof selection;
